@if (item()) {
  <div class="mix-and-segment flex">
    <div class="image-container size-12 xs:size-18 mr-2">
      <img [src]="imageUrl()" alt="Mix Image" />
    </div>
    <div>
      <div class="font-bold">
        {{ mixName() }}
      </div>
      <div class="">
        @if (showName()) {
          <div class="mt-1 font-semibold">
            {{ showName() }}
          </div>
        }
        @if (hostName()) {
          <div>
            {{ hostName() }}
          </div>
        }
        @if (broadcastedAt()) {
          <div>
            {{ broadcastedAt() }}
          </div>
        }
      </div>
    </div>
  </div>
  <div class="italic mt-2">
    {{ showDescription() }}
  </div>
}
